import React from 'react';
import { Award, Shield, FileCheck, GraduationCap, Briefcase } from 'lucide-react';
import { companyInfo } from '../data/mock';
import CertificateFlipCard from '@/components/CertificateFlipCard'
import { Card } from '@/components/ui/card'
import SEO from '@/components/SEO';

const Certificates = () => {
  const certificateDetails = [
    {
      id: 1,
      title: "Registered Valuer Certificate (U/s 34AB)",
      description: "Registered under Wealth Tax Act, 1957 – Registration No: CAT-1/756/2022-23",
      category: "Government Registration",
      year: "2022",
      image: "/certificates/registered_valuer_page1.png",
      logo: "/logos/income-tax-department.png"
    },
    {
      id: 2,
      title: "IIV Membership – CAT-I",
      description: "Approved Valuer – Immovable Property (CAT-I-A-5765)",
      category: "Professional Membership",
      year: "2020",
      image: "/certificates/iiv_cat1_membership.png",
      logo: "/logos/iiv-logo.png"
    },
    {
      id: 3,
      title: "IIV Membership – CAT-II",
      description: "Approved Valuer – Agricultural Land (CAT-II-A-6605)",
      category: "Professional Membership",
      year: "2023",
      image: "/certificates/iiv_cat2_membership.png",
      logo: "/logos/iiv-logo.png"
    },
    {
      id: 4,
      title: "Council of Engineers & Valuers",
      description: "Life Member – CEV/SM/1874/MV RE",
      category: "Professional Membership",
      year: "2021",
      image: "/certificates/cev_membership.png",
      logo: "/logos/cev-india-logo.png"
    },
    {
      id: 5,
      title: "Certificate of Practice (COP)",
      description: "CP No: 302 – Indian Institution of Valuers",
      category: "Professional Certification",
      year: "2023",
      image: "/certificates/cop_certificate.png",
      logo: "/logos/iiv-logo.png"
    },
    // {
    //   id: 6,
    //   title: "Educational Qualification",
    //   description: "M.Com – Valuation of Real Estate & Agriculture Land",
    //   category: "Education",
    //   year: "2019",
    //   image: "/certificates/education_certificate_1.png",
    // },
    // {
    //   id: 7,
    //   title: "Experience Certificate",
    //   description: "Assistant Valuer – S.J. Asset Appraisal Pvt. Ltd.",
    //   category: "Experience",
    //   year: "2018–2022",
    //   image: "/certificates/experience_certificate.png",
    // }
  ];

  return (
    <div className="bg-background pt-32 pb-20">
      <SEO
        title="Certifications & Credentials — Mehta Associates"
        description="Government-registered certifications and professional memberships of Mehta Associates. Registered valuer for immovable and agricultural property."
        pathname="/certificates"
        keywords={["registered valuer", "certified valuer Bhavnagar", "Mehta Associates"]}
      />
      <div className="container mx-auto px-4">
        {/* Header */}
        <div className="text-center mb-16">
          <h1 className="heading-1 text-foreground mb-6">CERTIFICATIONS & CREDENTIALS</h1>
          <p className="body-large text-muted max-w-3xl mx-auto">
            Government-approved certifications and professional memberships ensuring legal compliance and industry standards.
          </p>
        </div>

        {/* Main Certificates Grid - Flip Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-20">
          {certificateDetails.map((cert) => (
            <Card key={cert.id} className="rounded-xl shadow-sm border-border p-2">
              <CertificateFlipCard cert={cert} />
            </Card>
          ))}
        </div>

        {/* Regulatory Compliance */}
        <div className="bg-card p-12 border border-border mb-12">
          <h2 className="heading-4 text-foreground mb-8 text-center">Regulatory Compliance</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="text-center">
              <div className="w-20 h-20 bg-[#F4F7FB] rounded-full flex items-center justify-center mx-auto mb-4">
                <Shield className="text-foreground" size={36} />
              </div>
              <h3 className="heading-6 text-foreground mb-3">Government Guidelines</h3>
              <p className="body-small text-muted">
                All valuations follow Gujarat Government norms and RBI guidelines
              </p>
            </div>
            <div className="text-center">
              <div className="w-20 h-20 bg-[#F4F7FB] rounded-full flex items-center justify-center mx-auto mb-4">
                <FileCheck className="text-foreground" size={36} />
              </div>
              <h3 className="heading-6 text-foreground mb-3">Legal Validity</h3>
              <p className="body-small text-muted">
                Reports accepted by Income Tax, Wealth Tax, and all legal authorities
              </p>
            </div>
            <div className="text-center">
              <div className="w-20 h-20 bg-[#F4F7FB] rounded-full flex items-center justify-center mx-auto mb-4">
                <Award className="text-foreground" size={36} />
              </div>
              <h3 className="heading-6 text-foreground mb-3">Bank Approved</h3>
              <p className="body-small text-muted">
                Empanelled with major banks and NBFCs across Gujarat
              </p>
            </div>
          </div>
        </div>

        {/* Certificate List
        <div className="bg-card p-12 border border-border mb-12">
          <h2 className="heading-4 text-foreground mb-8 text-center">Professional Certifications</h2>
          <div className="max-w-3xl mx-auto space-y-4">
            {certificateDetails.map((cert) => (
              <div
                key={cert.id}
                className="bg-card p-6 border border-border flex items-start gap-4 hover:border-accent transition-colors"
              >
                <div className="w-12 h-12 bg-[#F4F7FB] rounded-lg flex items-center justify-center flex-shrink-0">
                  <FileCheck className="text-foreground" size={24} />
                </div>
                <div className="flex-1">
                  <h3 className="body-medium text-foreground mb-2">{cert.title}</h3>
                  <p className="body-small text-muted mb-2">{cert.description}</p>
                  <span className="caption text-muted">{cert.category}</span>
                </div>
              </div>
            ))}
          </div>
        </div> */}

        {/* Trust Badge */}
        <div className="text-center bg-card p-12 border-2 border-border">
          <Award className="text-foreground mx-auto mb-6" size={64} />
          <h2 className="heading-4 text-foreground mb-4">Trusted Professional Valuer</h2>
          <p className="body-medium text-muted mb-8 max-w-2xl mx-auto">
            With {companyInfo.experience} of certified experience and government approval, {companyInfo.name} provides reliable and legally compliant valuation services.
          </p>
          <div className="flex flex-wrap justify-center gap-8 text-sm text-[#888680]">
            <div className="flex items-center gap-2">
              <div className="w-3 h-3 bg-primary rounded-full"></div>
              <span>Govt. Registered</span>
            </div>
            <div className="flex items-center gap-2">
              <div className="w-3 h-3 bg-primary rounded-full"></div>
              <span>RVO Certified</span>
            </div>
            <div className="flex items-center gap-2">
              <div className="w-3 h-3 bg-primary rounded-full"></div>
              <span>Bank Empanelled</span>
            </div>
            <div className="flex items-center gap-2">
              <div className="w-3 h-3 bg-primary rounded-full"></div>
              <span>Legally Compliant</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Certificates;
